/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SimpleUserForUserRoleRelationVm,
    SimpleUserForUserRoleRelationVmFromJSON,
    SimpleUserForUserRoleRelationVmFromJSONTyped,
    SimpleUserForUserRoleRelationVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface SimpleUserForUserRoleRelationVmPaginatedSearchResponse
 */
export interface SimpleUserForUserRoleRelationVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<SimpleUserForUserRoleRelationVm>}
     * @memberof SimpleUserForUserRoleRelationVmPaginatedSearchResponse
     */
    items?: Array<SimpleUserForUserRoleRelationVm> | null;
    /**
     * 
     * @type {number}
     * @memberof SimpleUserForUserRoleRelationVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimpleUserForUserRoleRelationVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof SimpleUserForUserRoleRelationVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof SimpleUserForUserRoleRelationVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SimpleUserForUserRoleRelationVmPaginatedSearchResponse
     */
    size?: number;
}

export function SimpleUserForUserRoleRelationVmPaginatedSearchResponseFromJSON(json: any): SimpleUserForUserRoleRelationVmPaginatedSearchResponse {
    return SimpleUserForUserRoleRelationVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function SimpleUserForUserRoleRelationVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleUserForUserRoleRelationVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(SimpleUserForUserRoleRelationVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function SimpleUserForUserRoleRelationVmPaginatedSearchResponseToJSON(value?: SimpleUserForUserRoleRelationVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(SimpleUserForUserRoleRelationVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


